import React, { Component } from 'react';
import * as firebase from 'firebase';
import './App.css';
//import fire from './config/Fire';
import Home from './controller/Home';
import Search from './controller/Search';
import { ProfileSettings } from './controller/ProfileSettings';
import { Eventfeed } from './controller/Feed';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    withRouter,
    Link,
    Redirect
} from "react-router-dom";
import { Discovery } from './controller/Discovery';
import { CalendarPage } from './controller/CalendarPage';
import { AffiliateView } from './controller/AffiliateView';
import { AffiliateEvents } from './controller/AffiliateEvents';
import { AffiliateGallery } from './controller/AffiliateGallery';

class App extends Component {

    // put user in a state
    constructor(props) {
        super(props);
        this.logUser = this.logUser.bind(this);
        // this.logout = this.logout.bind(this);
        this.state = {
            user: {},
            pathURL: "/",
        }
    }

    componentDidMount() {
        this.authListener();
    }

    authListener() {
        firebase.auth().onAuthStateChanged((user) => {
            console.log(firebase.auth().currentUser);
            console.log("App auth");
            if (user) {
                this.setState({ user });
                console.log("I ENTERED HERE");

                // Local storage to retrieve UID
                //localStorage.setItem('user', user.uid);
            } else {
                this.setState({ user: null });

                //localStorage.removeItem('user');
            }
        });
    }

    logUser() {
        console.log(this.state.user);
    }

    // logout() {
    //   this.setState({user : null})
    // }

    render() {
        return (
            <Router>
                <Switch>
                    <Route path="/" exact component={Home} user={this.state.user} />
                    <Route path="/Profile" exact component={Eventfeed} />
                    <Route path="/Explore" exact component={Search} />
                    <Route path="/ProfileSettings" exact component={ProfileSettings} />
                    <Route path="/Discovery" exact component={Discovery} />
                    <Route path="/Calendar" exact component={CalendarPage} />
                    <Route path="/Affiliate/" component={AffiliateView} />
                    <Route path="/AffiliateEvents/" component={AffiliateEvents} />
                    <Route path="/AffiliateGallery/" component={AffiliateGallery} />
                </Switch>
            </Router>

        );
    }
}

export default App;
